module.exports = __webpack_public_path__ + "img/mycelium.bebdfdf1.svg";